'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _paths = require('ifeis-isomorphic/lib/redux/actions/scores/paths');

var _paths2 = require('ifeis-isomorphic/lib/redux/actions/comments/paths');

var _paths3 = require('ifeis-isomorphic/lib/redux/actions/dress-checks/paths');

var _paths4 = require('ifeis-isomorphic/lib/redux/actions/events/paths');

var _paths5 = require('ifeis-isomorphic/lib/redux/actions/adjudicators/paths');

var _immutable = require('immutable');

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

exports.default = function (feis_id, person_id, event_id) {
  return function (state) {

    var loading = false;
    var participants = (0, _paths4.getParticipantsOfAnEvent)(state, event_id);
    var placements = (0, _paths4.getEventPlacements)(state, event_id);

    var adjIds = (0, _paths5.getEventAdjudicatorIds)(state, event_id);

    if (!adjIds || adjIds && adjIds.size === 0 || !participants || participants && participants.get('loading') || !placements || placements && placements.size === 0) {
      return {
        loading: true,
        getAdjudicators: getAdjudicators,
        participants: participants,
        scores: scores,
        placements: placements
      };
    };

    if (adjIds.some(function (aid) {
      return !(0, _paths4.getEventScores)(state, event_id, aid) || (0, _paths4.getEventScores)(state, event_id, aid).get('loading') || (0, _paths4.getEventScores)(state, event_id, aid).size === 0 || (0, _paths4.areCommentsLoading)(state, event_id, aid, person_id) === true;
    })) {
      return {
        loading: true,
        getAdjudicators: getAdjudicators,
        participants: participants,
        scores: scores,
        placements: placements
      };
    };

    var getAdjudicators = adjIds.map(function (aid) {
      return (0, _paths5.adjudicators)(state, aid);
    });

    var commentsForPerson = [];
    var dressChecksForPerson = [];

    // first lets check if comments are present in comments part of store.
    adjIds.forEach(function (aid) {
      var commentIdsForPerson = (0, _paths4.getEventComment)(state, event_id, aid, person_id);
      var commentsForPersonByAnAdjudicator = commentIdsForPerson && commentIdsForPerson.map(function (cid) {
        return { adjudicator: aid, comments: (0, _paths2.getComment)(state, cid).toJS() };
      });
      commentsForPerson = commentsForPerson && [].concat(_toConsumableArray(commentsForPerson), _toConsumableArray(commentsForPersonByAnAdjudicator.toJS())) || commentsForPersonByAnAdjudicator.toJS();
      var dressIdForPerson = (0, _paths4.getEventDressCheck)(state, event_id, aid, person_id);
      var dressCheckForPersonByAnAdjudicator = dressIdForPerson && { adjudicator: aid, dressCheck: (0, _paths3.getDressCheck)(state, dressIdForPerson).toJS() };
      dressChecksForPerson.push(dressCheckForPersonByAnAdjudicator);
    });

    var scoreIdsForPersons = adjIds.map(function (aid) {
      return (0, _paths4.getEventScores)(state, event_id, aid);
    });

    var scores = scoreIdsForPersons.map(function (scoreIdsForPerson) {
      var personArrays = scoreIdsForPerson.keySeq().toArray();

      return personArrays.map(function (pid) {
        var scoresForPerson = scoreIdsForPerson.get(pid).map(function (sid) {
          return (0, _paths.getScore)(state, sid);
        });
        return { person: pid, scores: scoresForPerson.toJS() };
      });
    });

    if (scores.some(function (s) {
      return s === undefined;
    })) {
      return {
        loading: true,
        getAdjudicators: getAdjudicators,
        participants: participants,
        scores: scores,
        placements: placements
      };
    }

    return {
      loading: loading,
      adjudicators: getAdjudicators,
      comments: commentsForPerson,
      dressChecks: dressChecksForPerson || [],
      participants: participants,
      scores: scores.toJS(),
      placements: placements
    };
  };
};


//////////////////
// WEBPACK FOOTER
// ./result-list/mapStateToController.js
// module id = 507
// module chunks = 0